import React = require('react');
import { useState } from 'react';

export const HazardousActivitiesMoreInfo = () => {

  const [showMoreInfo, setShowMoreInfo] = useState(false);

  const changeShowMoreInfo = () => {
    setShowMoreInfo(!showMoreInfo)
  }

  return (
    <>
      <div>
        <p><strong>Standard Activities:</strong></p>
        <ul className="margin-bottom">
          <li>
            Most activities, such as snorkelling or tennis, are automatically included. You can check the list of
            standard activities&nbsp;
            <a
              className="pointer"
              href="https://www.admiral.com/travel-insurance/adventurous-sports-insurance#paragraph-10849"
              target="_blank"
              rel="noreferrer"
            >
              here
            </a>
          </li>
          <li>
            If your chosen activity appears on the standard list, simply select ‘No’ and continue.
          </li>
        </ul>
        <div className={'more-info margin-bottom'}
              onClick={changeShowMoreInfo}>{showMoreInfo ? ' Less information' : ' More information'}
        </div>
      </div>
      {showMoreInfo && (
        <>
          <div className={'bold margin-bottom'}>Extreme Sports:</div>
          <ul>
            <li>If you want cover for extreme sports, like skydiving or bungee jumping, you’ll need to add this to your policy.
              You can check the full list of extreme activities <a
                className="pointer"
                href="https://www.admiral.com/travel-insurance/adventurous-sports-insurance#paragraph-10850"
                target="_blank"
                rel="noreferrer"
              >
                here
              </a></li>
            <li>To add these to your policy, just give us a call and we’ll get everything sorted so you can finish your purchase.&nbsp;
              <a
                className="pointer"
                href="https://www.admiral.com/contact-us/travel"
                target="_blank"
                rel="noreferrer"
              >
                Contact Us
              </a></li>
          </ul>
        </>
      )}
    </>
  )
}
